export default __webpack_public_path__ + "static/media/plus.14100e6f.png";